import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-check.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const CheckIcon = createSvgIcon(<Icon />, 'CheckIcon');
